module.exports = __webpack_public_path__ + "img/1_of_Clubs.svg.ecc8150e.png";